import API_BASE_URL from './urlHelper';
import { fetchWithAuth } from './authToken';

export async function fetchGestionMorasJson(
  path,
  {
    method = 'GET',
    params,
    payload,
    fallbackMessage = 'Error al cargar la gestión de moras',
    requireSuccessFlag = true
  } = {}
) {
  const url = buildGestionMorasUrl(path, params);
  const headers = { Accept: 'application/json' };

  if (payload !== undefined) {
    headers['Content-Type'] = 'application/json';
  }

  const res = await fetchWithAuth(url, {
    method,
    headers,
    ...(payload !== undefined ? { body: JSON.stringify(payload) } : {}),
  });

  if (!res.ok) {
    throw new Error(await obtenerMensajeError(res, fallbackMessage));
  }

  const data = await res.json();

  if (requireSuccessFlag && !data.success) {
    throw new Error(data.message || fallbackMessage);
  }

  return data;
}

export function normalizarAlertaCompromisos(payload = {}) {
  const totales = payload?.totales ?? {};

  return {
    fecha: payload?.fecha ?? null,
    diasAlerta: Number(payload?.dias_alerta ?? 0),
    hayAlertas: Boolean(payload?.hay_alertas),
    totales: {
      prestamosEnMora: Number(totales?.prestamos_en_mora ?? 0),
      sinCompromiso: Number(totales?.sin_compromiso ?? 0),
      compromisosVencidos: Number(totales?.compromisos_vencidos ?? 0),
      compromisosVenceHoy: Number(totales?.compromisos_vence_hoy ?? 0),
      compromisosPorVencer: Number(totales?.compromisos_por_vencer ?? 0),
      asesoresConPendientes: Number(totales?.asesores_con_pendientes ?? 0),
    },
  };
}

function buildGestionMorasUrl(path, params = {}) {
  const query = toQuery(params);

  return `${API_BASE_URL}${path}${query ? `?${query}` : ''}`;
}

function toQuery(params = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.set(key, value);
    }
  });

  return searchParams.toString();
}

async function obtenerMensajeError(response, fallbackMessage = 'Error al cargar la gestión de moras') {
  const mensajesError = {
    401: 'Sesión expirada. Por favor, inicie sesión nuevamente.',
    403: 'No tiene permisos para acceder a esta información.',
    404: 'El recurso solicitado no existe.',
  };

  if (mensajesError[response.status]) {
    return mensajesError[response.status];
  }

  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    const body = await response.json().catch(() => null);

    if (body?.errors && typeof body.errors === 'object') {
      const detalles = Object.values(body.errors)
        .flat()
        .filter(Boolean)
        .join(' ');

      if (detalles) {
        return detalles;
      }
    }

    if (body?.message) {
      return body.message;
    }
  }

  const body = await response.text().catch(() => '');
  return `Error ${response.status}: ${body || fallbackMessage}`;
}